/**
 * The files to be uploaded
 */
export class MatFileInput {
    private readonly _fileNames: string;

    constructor(private readonly _files: File[] | null, private readonly delimiter: string = ', ') {
        this._fileNames = (this._files || []).map((f: File) => f.name).join(delimiter);
    }

    get files() {
        return this._files || [];
    }

    get fileNames(): string {
        return this._fileNames;
    }
}
